export default __webpack_public_path__ + "static/media/11d.123f753c.png";